export const GET_APP_INFO_ENDPOINT =
 process.env.REACT_APP_GET_APP_INFO_ENDPOINT;
